import Modal from "../../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeAccionViewModal } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";
import Loader from "../../UI/Loader";
import Field from "../../UI/Field";
import AuditInfo from "../../UI/AuditInfo";

const AccionViewModalPlantel = () => {
  const dispatch = useDispatch();
  const { accionViewModalOpen, selectedAccion, selectedAccionLoading, selectedAccionError } = useSelector((state) => state.fortalezasPlantel);

  return (
    <Modal open={accionViewModalOpen} onClose={() => dispatch(closeAccionViewModal())} title="Detalle de la acción" size="lg">
      {selectedAccionLoading && <Loader center text="Cargando..." delay={150} type="dots" />}
      {selectedAccionError && <p className="text-danger">{selectedAccionError}</p>}
      {!selectedAccionLoading && selectedAccion && (
        <div className="row g-4">
          <div className="col-12"><Field icon="mdi:lightbulb-outline" label="Acción / Frase" value={selectedAccion.frase} justify /></div>
          <div className="col-md-6"><Field icon="mdi:shape-outline" label="Área de desarrollo" value={selectedAccion.area_texto || selectedAccion.area || "-"} /></div>
          <div className="col-md-6"><Field icon="mdi:star-outline" label="Talento" value={selectedAccion.talento_nombre || selectedAccion.talento || "-"} /></div>
          <div className="col-12">
            <Field icon="mdi:toggle-switch" label="Estado" value={
              <span className={`badge ${selectedAccion.is_active ? "bg-success-focus text-success-main" : "bg-neutral-200 text-neutral-600"} px-3 py-2`}>
                {selectedAccion.is_active ? "Activa" : "Inactiva"}
              </span>
            } />
          </div>
          <div className="col-12"><AuditInfo createdAt={selectedAccion.created_at} updatedAt={selectedAccion.updated_at} createdBy={selectedAccion.created_by} updatedBy={selectedAccion.updated_by} /></div>
        </div>
      )}
    </Modal>
  );
};

export default AccionViewModalPlantel;
